import { useEffect, useState } from "react";
import { getByIdProduct, updateProduct } from "../services";
import { toast } from "react-toastify";


export const useProductById = (productId) => {

const [product, setProduct] = useState(null);

  useEffect(() => {
    async function fetchProduct() {
      try {
        const { data } = await getByIdProduct(productId);
        setProduct(data);
      } catch (error) {
        toast.error("Erro ao buscar o produto");
      
      }
    }

    fetchProduct();
  }, [productId]);

  const handleSubmit = async (values) => {
    try {
      await updateProduct(productId, {
				...values,
				dashboardDescription: values.dashboard_description,
			});
      toast.success("Produto atualizado com sucesso!");
    
    } catch (error) {
      toast.error("Erro ao atualizar o produto");
    }
  };


	return { product, handleSubmit }
}
